import React, {
    useLayoutEffect,
    useRef,
    useEffect,
    useState,
} from 'react';

import { getActiveBanners } from '../../utils/BannerUtils';
import './Banners.scss';

const Banners = ({
    banners = [],
    currentTime: currentTimeOverride = null,
}) => {
    const [currentTime, setCurrentTime] = useState(new Date());
    const bannersRef = useRef(null);

    const effectiveCurrentTime =
        currentTimeOverride || currentTime;

    const activeBanners = getActiveBanners(
        banners,
        effectiveCurrentTime
    );

    useEffect(() => {
        if (currentTimeOverride) {
            return;
        }

        setCurrentTime(new Date());
    }, [banners, currentTimeOverride]);

    useEffect(() => {
        if (currentTimeOverride || banners.length === 0) {
            return;
        }
        const now = Date.now();
        const nextBannerTime = banners.flatMap((banner) => {
                const start = new Date(banner.startDate);
                if (Number.isNaN(start.getTime())) {
                    return [];
                }
                start.setSeconds(0, 0);
                const end = new Date(banner.endDate);
                if (Number.isNaN(end.getTime())) {
                    return [];
                }
                end.setSeconds(59, 999);
                return [
                    start.getTime(),
                    end.getTime() + 1,
                ];
            })
            .filter((time) => time > now)
            .sort((a, b) => a - b)[0];
    
        if (!nextBannerTime) {
            return;
        }
    
        const delay = Math.max(
            nextBannerTime - Date.now(),
            0
        );
    
        const timeout = setTimeout(() => {
            setCurrentTime(new Date());
        }, delay);
    
        return () => clearTimeout(timeout);
    }, [banners, currentTimeOverride, currentTime]);

    useLayoutEffect(() => {
        const height =
            activeBanners.length > 0
                ? bannersRef.current?.offsetHeight || 0
                : 0;

        document.documentElement.style.setProperty(
            '--active-banners-height',
            `${height}px`
        );

        return () => {
            document.documentElement.style.setProperty(
                '--active-banners-height',
                '0px'
            );
        };
    }, [activeBanners.length]);

    if (activeBanners.length === 0) {
        return null;
    }

    return (
        <div
            className="active-banners-container"
            ref={bannersRef}
        >
            {activeBanners.map((banner) => (
                <div
                    className={`active-banner active-banner-${banner.type}`}
                    key={banner._id}
                >
                    <div
                        className="active-banner-message"
                        dangerouslySetInnerHTML={{
                            __html: banner.message,
                        }}
                    />
                </div>
            ))}
        </div>
    );
};

export default Banners;